import { render } from "./IconCreditCard.vue?vue&type=template&id=4ad530ac"
import script from "./IconCreditCard.vue?vue&type=script&lang=js"
export * from "./IconCreditCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__